export default __webpack_public_path__ + "static/media/trr-drink-coffee-coldbrew.34415a84.png";